export default __webpack_public_path__ + "static/media/ep--success-filled.24f35455.svg";